export interface ApiDefaultParams {
  transactionChannel: string;
  posSystem: string;
}

export const API_DEFAULT_PARAMS: ApiDefaultParams = {
  transactionChannel: 'POS',
  posSystem: 'APP_PATHE_PAYMENT',
};
